import React, { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Link, Outlet } from 'react-router-dom';
import Loader from './component/loader';

const TestPage = React.lazy(() => import('./pages/ajay/index'));
// All Headers
const Header1 = React.lazy(() => import('./layouts/header/Header1'));
const Header2 = React.lazy(() => import('./layouts/header/header2'));
const Header3 = React.lazy(() => import('./layouts/header/header3'));

// All Footers
const FooterStyle01 = React.lazy(
  () => import('./layouts/footer/footer-style-01')
);
const FooterStyle02 = React.lazy(
  () => import('./layouts/footer/footer-style-02')
);
const FooterStyle03 = React.lazy(
  () => import('./layouts/footer/footer-style-03')
);
const BackTop = React.lazy(() => import('./component/back-top'));

// Home
const HomeIndex = React.lazy(() => import('./pages/home/index'));

const Blog = React.lazy(() => import('./pages/blog/Blog'));
const BlogGrid = React.lazy(() => import('./pages/blog/blog-grid'));
const BlogSingle = React.lazy(() => import('./pages/blog/blog-details'));
const CaseStudy = React.lazy(() => import('./pages/case-study/case-study'));
const CaseStudySingle = React.lazy(
  () => import('./pages/case-study/case-study-details')
);
const ContactUs = React.lazy(() => import('./pages/contact/contact'));
const Pricing = React.lazy(() => import('./pages/pricing'));
const Faq = React.lazy(() => import('./pages/faq/faq'));
const ComingSoon = React.lazy(() => import('./pages/coming-soon'));
const Error404 = React.lazy(() => import('./pages/error404/error404'));
const PrivacyPolicy = React.lazy(() => import('./pages/privacy-policy'));
const TermsConditions = React.lazy(() => import('./pages/terms-conditions'));

// Pages
const AboutUs = React.lazy(() => import('./pages/about-us'));
const Careers = React.lazy(() => import('./pages/careers'));
const HowWeWork = React.lazy(() => import('./pages/how-we-work'));
const Team = React.lazy(() => import('./pages/team/team'));
const TeamSingle = React.lazy(() => import('./pages/team/team-single'));
const MissionVision = React.lazy(() => import('./pages/mission-vision'));
const OurValue = React.lazy(() => import('./pages/our-value'));
const Service = React.lazy(() => import('./pages/services/services'));
const ServicesSingle = React.lazy(
  () => import('./pages/services/services-details')
);
const Industries = React.lazy(() => import('./pages/industries'));
const Industries2 = React.lazy(() => import('./pages/industries/industries-2'));
const Industries3 = React.lazy(() => import('./pages/industries/industries-3'));
const Industries4 = React.lazy(() => import('./pages/industries/industries-4'));

// All Elements
const ElementsActionBox = React.lazy(() => import('./elements/action-box'));
const ElementsAccordion = React.lazy(() => import('./elements/accordion'));
const ElementsButton = React.lazy(() => import('./elements/button'));
const ElementsBlog = React.lazy(() => import('./elements/blog'));
const ElementsClientLogo = React.lazy(() => import('./elements/client-logo'));
const ElementsServices = React.lazy(() => import('./elements/services'));
const ElementsServiceBox = React.lazy(() => import('./elements/service-box'));
const ElementsCategoryBox = React.lazy(() => import('./elements/category-box'));
const ElementsCaseStudy = React.lazy(() => import('./elements/case-study'));
const ElementsCountdown = React.lazy(() => import('./elements/countdown'));
const ElementsCounter = React.lazy(() => import('./elements/counter'));
const ElementsTestimonial = React.lazy(() => import('./elements/testimonial'));
const ElementsInfoBox = React.lazy(() => import('./elements/infobox'));
const ElementsFeatureStep = React.lazy(() => import('./elements/feature-step'));
const ElementsPricingTable = React.lazy(
  () => import('./elements/pricing-table')
);
const ElementsTeam = React.lazy(() => import('./elements/team'));
const ElementsTabs = React.lazy(() => import('./elements/tabs'));
const ElementsImageGallery = React.lazy(
  () => import('./elements/image-gallery')
);
const ResponsiveMenu = React.lazy(() => import('./elements/menu'));
const ElementsFeatureInfo = React.lazy(() => import('./elements/feature-info'));
const ElementsList = React.lazy(() => import('./elements/list'));
const ElementsVideo = React.lazy(() => import('./elements/video'));

function App() {
  const location = useLocation();
  const hideFooter = location.pathname !== '/coming-soon';

  return (
    <Suspense fallback={<Loader />}>
      <div className="main-wrapper">
        <Header1 />
        <outlet />
        <FooterStyle01 />
      </div>
    </Suspense>
  );
}

export default App;
